bindLinkclicker();

function bindLinkclicker() {
    const linkContainerSelector =`
        [data-linkclicker="area"],
        [data-linkclicker="area-nobubble"],
        [data-linkclicker="area-img"]
    `;
    const linkContainer = document.querySelectorAll(linkContainerSelector);
    if (!linkContainer) return;

    let createClicker = document.createElement('div');
    createClicker.classList.add('lk', 'lk_micro');
    document.body.appendChild(createClicker);

    var linkClicker = document.querySelector('.lk');
    linkClicker.innerHTML = `
        <div class="lk__content"></div>`;

    function positionCursor(event) {
        let posY = event.clientY - 55;
        let posX = event.clientX - 45;

        linkClicker.setAttribute("style", `transform: translate(${posX}px, ${posY}px)`);
    }

    window.addEventListener('mousemove', event => {
        positionCursor(event);
    });

    linkContainer.forEach(c => {
        c.classList.add('lk__area');

        const type = c.dataset.linkclicker;
        const bubleContent = c.dataset.bubblecontent ? c.dataset.bubblecontent : 'read'

        let linkTarget = c.querySelector('[data-linkclicker="link"]');

        switch(type) {
            case 'area-nobubble':
                break;
            case 'area-img':
                if (!window.mobileTrigger) growBubble(bubleContent, 'img');
                break;
            case 'area':
                if (!window.mobileTrigger) growBubble(bubleContent, 'text');
        }

        function growBubble(content, type){
            const lkBody = document.querySelector('.lk__content');

            c.addEventListener('mouseenter', () => {
                switch(type) {
                case 'img':
                    bubbleImg(content);
                    break;
                case 'text':
                    bubbleText(content);
                    break;
            }

            function bubbleText(text){
                lkBody.innerHTML = `<span>${text}</span>`
            }

            function bubbleImg(img){
                lkBody.innerHTML = `<img src="${img}" >`
            }

                linkClicker.classList.remove('lk_micro');
            });

            c.addEventListener('mouseleave', () => {
                linkClicker.classList.add('lk_micro');
                lkBody.innerHTML = '';
            });
        }
    })

    document.addEventListener('click', event => {
        event.stopPropagation();
        const target = event.target.closest('[data-click]');
        if (!target) return;
        if (window.mobileTrigger && target.closest('cryptolist__tr')) {
            return;
        }
        console.log(target);
        window.location = document.querySelector(target.dataset.click).href;
    });

    document.addEventListener('click', event => {
        event.stopPropagation();
        const target = event.target.closest(linkContainerSelector);
        if (!target) return;
        if ($(event.target).is('[data-linkclicker-ignore]')) return;

        const type = target.dataset.linkclicker;

        if (target.querySelector('[data-linkclicker="link"]')) {
            var linkTarget = target.querySelector('[data-linkclicker="link"]');
        } else {
            var linkTarget = document.querySelector(target.dataset.linkclickerTarget);
        };

        if (!window.mobileTrigger && target.dataset.ignoreDesktop) return;

        if(linkTarget.target == '_blank') {
            event.preventDefault();
            window.open(linkTarget.href, '_blank')
        } else {
            window.location = linkTarget.href
        }
    })
}
